import React, { useState } from "react";
import {
  Button,
  CircularProgress,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

import Modal from "./Modal";

const CommentInputForReason = ({
  handleSubmit,
  handleClose,
  isLoading,
  isOpen,
  title,
  errorMessage,
  t,
}) => {
  const [isError, setIsError] = useState(false);
  const [comment, setComment] = useState("");

  const theme = useTheme();

  const submitHandler = async () => {
    if (comment) {
      await handleSubmit(comment);
      setComment("");
    } else {
      setIsError(true);
    }
  };

  return (
    <div className="mt-2">
      <Modal
        title={title}
        isOpen={isOpen}
        handleClose={() => {
          handleClose();
          setIsError(false);
          setComment("");
        }}
        maxWidth="sm"
      >
        <>
          <TextField
            placeholder={t("Add a comment") + "..."}
            className="mb-1 mt-2"
            multiline
            rows={3}
            error={isError}
            value={comment}
            onChange={(e) => {
              setComment(e.target.value);
              setIsError(!e.target.value);
            }}
            fullWidth
            size="small"
          />
          <Typography
            variant="subtitle2"
            className={` ${
              isError ? "visible" : "invisible"
            } input-field-error-message`}
            sx={{ color: theme.palette.error.main }}
          >
            {t(`${errorMessage}`)}
          </Typography>
          <div className="d-flex justify-content-end gap-1">
            <Button
              variant="contained"
              size="small"
              onClick={submitHandler}
              startIcon={isLoading ? <CircularProgress size={20} /> : null}
              disabled={isLoading}
            >
              {t("Submit")}
            </Button>
          </div>
        </>
      </Modal>
    </div>
  );
};

CommentInputForReason.propTypes = {
  handleSubmit: PropTypes.func,
  handleClose: PropTypes.func,
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  errorMessage: PropTypes.string,
  t: PropTypes.func,
};

export default withTranslation()(CommentInputForReason);
